import axios from 'axios';
import {api} from '../constants/api';
import {errors as E} from 'common/constants/errors';

export const findCustomer = (customerName) => dispatch => {
  const data = {customerName};

  return axios.post(api.FIND_CUSTOMER, data)
    .then(response => {
      const {body, errorCode} = response.data;
      if (errorCode < 0) throw new Error(E.SERVER_ERROR);

      return {options: body.customers};
    });
};
